var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.559 9.02L15.479 9.94L6.41902 19H5.49902V18.08L14.559 9.02ZM18.159 3C17.909 3 17.649 3.1 17.459 3.29L15.629 5.12L19.379 8.87L21.209 7.04C21.599 6.65 21.599 6.02 21.209 5.63L18.869 3.29C18.669 3.09 18.419 3 18.159 3ZM14.559 6.19L3.49902 17.25V21H7.24902L18.309 9.94L14.559 6.19Z",
    fill: "#5F8FDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3304f102fc69092e710d4914a0f116bb.svg";
export { ForwardRef as ReactComponent };